export default "__VITE_ASSET__BSfIgxwk__"